<div class="errors-wrapper" [class.hidden]="!(hasErrors$ | ngrxPush)">
    <div class="error-icon">
        <dtm-ui-icon name="error-warning"></dtm-ui-icon>
    </div>
    <div class="errors" #errorsContainer role="alert" [id]="errorId$ | ngrxPush">
        <ng-content></ng-content>
    </div>
</div>
